import { render, staticRenderFns } from "./Safety3.vue?vue&type=template&id=7a23367a&scoped=true"
import script from "./Safety3.vue?vue&type=script&lang=js"
export * from "./Safety3.vue?vue&type=script&lang=js"
import style0 from "./Safety3.vue?vue&type=style&index=0&id=7a23367a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23367a",
  null
  
)

export default component.exports